import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import RedeemIcon from '@material-ui/icons/Redeem'
import Container from '@material-ui/core/Container'
import { FRISCO_COACHING_CENTER_SLUG } from 'utils/constants'
import { gtmEvent } from 'lib/gtm'
import { PGA_COM_HOST, MY_PGA_COM_HOST } from 'env'
import { DownloadMyPGAsection } from 'components/download-mypga-section'
import TransactionSummary from '../../schedule/components/transaction-summary'
import StudentProfileCTA from '../../schedule/components/StudentProfileCTA'
import AlertWithDivider from '../../schedule/components/AlertWithDivider'
import SummaryDetails from '../summary-details'
import { useStyles } from '../styles'

const LessonPackPurchaseConfirmation = ({
  lessonPack,
  fetchedStudent,
  studentLoading,
  studentError,
}) => {
  const classes = useStyles()
  const history = useHistory()
  const { studentId } = useParams()

  const { lessonType, priceInCents, registrationPayments, quantity } =
    lessonPack || {}
  const { cardBrand, last4 } = registrationPayments?.[0] || {}
  const previousUrl = document.referrer
  const coachBookingUrl = lessonType?.coach?.bookingUrl || ''
  const isFCCBooking = previousUrl.includes(FRISCO_COACHING_CENTER_SLUG)
  const { golferProfile } = fetchedStudent?.student || {}

  const lessonTypeId = lessonType?.id
  const locationId = lessonType?.facilities?.[0]?.id

  const bookNewSessionUrl = isFCCBooking
    ? coachBookingUrl
    : `${coachBookingUrl}?lessonTypeId=${lessonTypeId}&locationId=${locationId}&lessonCreditBalanceQuantity=${quantity}`

  const giftLessonPackUrl = '/club/lesson-packs'

  const onBookNow = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-book-now-button',
    })
    history.push(bookNewSessionUrl.split(MY_PGA_COM_HOST)[1])
  }

  const onCoachingCenterBooking = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-book-another-session-button',
    })
    window.open(`${PGA_COM_HOST}/${FRISCO_COACHING_CENTER_SLUG}`, '_blank')
  }

  const onViewCoachOfferings = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'book-session',
      formAction: 'clicked-view-coachofferings-button',
    })
    history.push(coachBookingUrl.split(MY_PGA_COM_HOST)[1])
  }

  const onViewLessonPack = () => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'lesson-pack',
      formAction: 'clicked-view-lesson-pack-button',
    })
    history.push('/club/lesson-packs')
  }

  return (
    <Container className={classes.root} maxWidth="sm">
      <TransactionSummary
        priceInCents={priceInCents}
        cardBrand={cardBrand}
        lastDigits={last4}
        selectedLessonPack={lessonPack}
      />
      <SummaryDetails
        lessonType={lessonType}
        coach={lessonType?.coach}
        selectedLessonPack={lessonPack}
        classes={classes}
      />
      <Box display="flex" justifyContent="center" flexWrap="wrap" width="100%">
        {studentLoading && <CircularProgress />}
        {isFCCBooking && !studentError && (
          <>
            <Divider className={classes.paddedDivider} />
            <StudentProfileCTA
              golferProfile={golferProfile}
              studentId={studentId}
            />
            <Divider className={classes.paddedDivider} />
          </>
        )}
        {lessonType?.giftingEnabled ? (
          <Button
            variant="outlined"
            color="primary"
            className={`${classes.details} ${classes.buttonStyles}`}
            onClick={onViewLessonPack}
          >
            View Lesson Pack
          </Button>
        ) : isFCCBooking ? (
          <Button
            color="primary"
            variant="outlined"
            className={`${classes.details} ${classes.altButtonStyle}`}
            onClick={onCoachingCenterBooking}
            children={'View Offerings'}
          />
        ) : (
          <Button
            color="primary"
            variant="outlined"
            className={`${classes.details} ${classes.altButtonStyle}`}
            onClick={onViewCoachOfferings}
            children={'View Coach Offerings'}
          />
        )}
        <Button
          variant="contained"
          color="primary"
          className={`${classes.details} ${classes.buttonStyles}`}
          onClick={onBookNow}
        >
          Book Now
        </Button>
        {lessonType?.giftingEnabled && (
          <AlertWithDivider
            icon={<RedeemIcon />}
            text="Gift this Lesson Pack at any time by visiting the Lesson Packs page."
            ctaLink={giftLessonPackUrl}
            ctaLinkText="GIFT"
          />
        )}
      </Box>
      <DownloadMyPGAsection />
    </Container>
  )
}

export default LessonPackPurchaseConfirmation
